import React from 'react';
interface StepNameProps {
  name: string;
  onChange: (name: string) => void;
}
export function StepName({
  name,
  onChange
}: StepNameProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-8" data-id="element-2654">
      <div data-id="element-2655">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2656">
          Cum o numești?
        </h2>
        <p className="text-sm text-light-3" data-id="element-2657">
          Un nume scurt care te ajută să o recunoști rapid în lista ta.
        </p>
      </div>

      <div data-id="element-2658">
        <label className="block text-xs font-medium text-light-3 uppercase tracking-wider mb-2" data-id="element-2659">
          Nume proprietate <span className="text-lime-1" data-id="element-2660">*</span>
        </label>
        <input type="text" value={name} onChange={e => onChange(e.target.value)} placeholder="ex. Cotroceni · 2 camere" autoFocus className="w-full h-12 px-4 rounded-xl bg-dark-2 border border-dark-4 text-base text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2661" />
      </div>
    </div>;
}